// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import lang from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'

// 引入svg-icon
import '@/icons'

// 引入图表插件 http://echarts.baidu.com/tutorial.html
import echarts from 'echarts'

import '@/styles/index.scss'

import App from './App'
import router from './router'
import store from './store'
import './utils/permission' // permission control

import './lib/aliyun-upload-sdk/lib/es6-promise.min.js'
import './lib/aliyun-upload-sdk/lib/aliyun-oss-sdk-5.3.1.min.js'
import './lib/aliyun-upload-sdk/aliyun-upload-sdk-1.5.0.min.js'

Vue.prototype.$echarts = echarts

Vue.use(ElementUI);
locale.use(lang)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js